export const imageCodes = {
    port1: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio1.jpg?alt=media&token=24b06ee2-0fca-4d6c-9dc9-829fe35a6980"
    },
    port3: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio3.jpg?alt=media&token=ed37a84a-a779-4888-ba81-40761703d52c"
    },
    port4: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio4.jpg?alt=media&token=39b94acf-3ce4-46ad-b81d-c78ef9ad2e53"
    },
    port5: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio5.jpg?alt=media&token=a04e6eee-34eb-4559-a9c4-c3d6257591c9"
    },
    port6: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio6.jpg?alt=media&token=21a087f6-89b6-4336-9803-1398a4d5b694"
    },
    port7: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio7.jpg?alt=media&token=f53f441f-5422-4aa8-9322-ca3ab770e68d"
    },
    port8: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio8.jpg?alt=media&token=bc6485b0-2962-437d-b9cf-6dec7345309f"
    },
    port9: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio9.jpg?alt=media&token=f0fc9940-3665-4cc1-9c43-7a9af185812e"
    },
    port10: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio10.jpg?alt=media&token=e0bc770e-aff6-4b69-9900-fffdfefc385e"
    },
    port11: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio11.jpg?alt=media&token=a4183689-a2b0-402d-b161-eb1f2aad36eb"
    },
    port12: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio12.png?alt=media&token=0fbfe65e-3547-48d0-9c69-8a5ed0d03d6a"
    },
    port13: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio13.jpg?alt=media&token=be2a75e0-c41f-4746-8307-4c41766d5118"
    },
    port14: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio14.jpg?alt=media&token=9e96a1e5-8338-478e-99e1-ff780b12fae3"
    },
    port15: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffounder_sologan.png?alt=media&token=5e56afe2-c2c8-4cd3-9834-85f79b803a78"
    },
    port16: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fchoose_reason.jpg?alt=media&token=d9b54850-86c7-4475-9b47-3fa9f1aa9780"
    },
    port17: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhero2.jpg?alt=media&token=a60439c8-c83a-4b7c-962a-a463bac4ac9f"
    },
}

export const textCodes = {
    porttext: {
        code: "${merchantId}_tmpl_text_2",
        text: "Asteria, is a online clothing store for women based in Myanmar. It expects to captivate customers' interests with its minimalist, local made designs."
    },
}

export const titleCodes = {
    
    portfolio: {
        code: "${merchantId}_tmpl_title_6",
        title: "Our Portfolio"
    },
}
